module.exports = __webpack_public_path__ + "img/logo.a91d17a9.svg";